.cx{padding:0.5rem;}